import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import DriverWageAccount from './driver-wage-account.jsx';

export default class DriversWageAccounts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.initialValue || 'placeholder',
      drivers_wage_accounts: props.driversWageAccountsAll || [],
      isLoading: true,
      url: props.url || '/api/v1/drivers/wage-accounts'
    };

    if (this.state.isLoading === true) {
      this.getDriversWageAccounts();
    }
  }

  getDriversWageAccounts() {
    let url = this.state.url;
    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token
        ,"Accept": 'application/json'
      },
    }).
    then((responseText) => {
      let response = responseText.json();
      response.then((driversWageAccountsJson) => {
        this.setState({
          drivers_wage_accounts: driversWageAccountsJson,
          isLoading: false,
        })
      });
    });
  }
  handleExpandAllDriverWages(e,allDriverIds){
    if(allDriverIds && allDriverIds.length > 0){
      let expandBox = "";
      let expandContainer = "";
      allDriverIds.map(function(id) {
        expandBox = expandBox+'#driver-expanded-wages-list-'+id+',';
        expandContainer = expandContainer+'#driver-wage-account-'+id+',';
      });
      expandBox = expandBox.substring(0,expandBox.length - 1);
      expandContainer = expandContainer.substring(0,expandContainer.length - 1);
      $(expandBox).slideToggle(200);
      $(expandContainer).toggleClass('wage-container-expanded');
    }
  }
  render() {
  let DriversWageAccounts = [];
  let allDriverIds = [];
  if (this.state.drivers_wage_accounts &&
    this.state.drivers_wage_accounts.length > 0) {
      this.state.drivers_wage_accounts.forEach(function(i) {
        allDriverIds.push(i.id);
        DriversWageAccounts.push(
          <DriverWageAccount
            key={'drivers-wage-accounts-'+i.id}
            data={i}
          />
       );
    });
  }
  return (<div> 
    <div className="text-center">
      <button className="btn btn-primary btn-lg" onClick={(e)=>this.handleExpandAllDriverWages(e,allDriverIds)}>
        Expand All Drivers
      </button>
      <br/>
    </div>
    {
    this.state.isLoading ?(
      <div className="loading-box">
        <span className="add-loading-text">
          <i className="fa fa-spinner fa-pulse"></i>
        </span>
      </div>
    ) : DriversWageAccounts}
  </div>)
  }
}
if (document.getElementById(
      'react-component-g4-logistics-portal-drivers-wages')) {
    ReactDOM.render(
    <DriversWageAccounts
      url = {"/api/v1/portal/drivers/wage-accounts"}
      message_if_none = 'Invoice accounts not found or available for viewing.'
    />,
    document.getElementById(
      'react-component-g4-logistics-portal-drivers-wages'
    )
  );
}
